import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';
import { galleryImages } from '../data/mockData';
import '../styles/gallery.css';

const GallerySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const openLightbox = (index) => {
    setLightboxIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

  const nextLightbox = () => {
    setLightboxIndex((prev) => (prev + 1) % galleryImages.length);
  };

  const prevLightbox = () => {
    setLightboxIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  const getVisibleImages = () => {
    const images = [];
    for (let i = -1; i <= 1; i++) {
      const index = (currentIndex + i + galleryImages.length) % galleryImages.length;
      images.push({ ...galleryImages[index], position: i });
    }
    return images;
  };

  return (
    <section id="gallery" className="gallery-section">
      {/* Cricket Ball Decorations */}
      <div className="cricket-ball cricket-ball-1"></div>
      <div className="cricket-ball cricket-ball-2"></div>
      
      <div className="container">
        <div className="gallery-header">
          <div className="section-label">
            <span>Gallery</span>
          </div>
          <h2 className="section-title">
            Witness the <span className="text-highlight">Cricket Excellence</span>
          </h2>
          <p className="gallery-subtitle">
            Moments captured from our training sessions, facilities, and success stories
          </p>
        </div>

        {/* Cricket Stadium Carousel */}
        <div className="stadium-carousel">
          <div className="stadium-boundary">
            <div className="pitch-line pitch-line-left"></div>
            <div className="pitch-line pitch-line-right"></div>
            
            <div className="carousel-track">
              {getVisibleImages().map((image, idx) => (
                <div
                  key={image.id}
                  className={`carousel-card position-${image.position === -1 ? 'left' : image.position === 0 ? 'center' : 'right'}`}
                  onClick={() => image.position === 0 && openLightbox(currentIndex)}
                >
                  <div className="card-frame">
                    <img src={image.url} alt={image.title} className="gallery-image" />
                    <div className="image-overlay-gradient"></div>
                  </div>
                  {image.position === 0 && (
                    <div className="card-info">
                      <h3 className="card-title">{image.title}</h3>
                      <p className="card-description">{image.description}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
            
            {/* Cricket Stumps Navigation */}
            <button className="carousel-nav nav-prev" onClick={prevSlide}>
              <ChevronLeft size={32} />
            </button>
            <button className="carousel-nav nav-next" onClick={nextSlide}>
              <ChevronRight size={32} />
            </button>
          </div>

          {/* Progress Dots */}
          <div className="carousel-dots">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>

        {/* Thumbnail Grid */}
        <div className="thumbnail-grid">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            >
              <img src={image.url} alt={image.title} />
              <div className="thumbnail-overlay">
                <span>{image.title}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {isLightboxOpen && (
        <div className="lightbox" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox}>
            <X size={32} />
          </button>
          <button className="lightbox-nav lightbox-prev" onClick={(e) => { e.stopPropagation(); prevLightbox(); }}>
            <ChevronLeft size={40} />
          </button>
          <button className="lightbox-nav lightbox-next" onClick={(e) => { e.stopPropagation(); nextLightbox(); }}>
            <ChevronRight size={40} />
          </button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img src={galleryImages[lightboxIndex].url} alt={galleryImages[lightboxIndex].title} />
            <div className="lightbox-info">
              <h3>{galleryImages[lightboxIndex].title}</h3>
              <p>{galleryImages[lightboxIndex].description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
